import React from "react";
import { Box, Typography } from "@mui/material";
import CreateForm from "@/templates/PromptTemplate/CreateForm";
import useBossBabyCreatePromptTemplate from "./useBossBabyCreatePromptTemplate";

/**
 * 보스베이비 프롬프트 템플릿 생성 페이지
 *
 * @description 보스베이비 채팅 프롬프트 템플릿을 생성하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export default function BossBabyCreatePromptTemplatePage() {
  const {
    form,
    loading,
    handleSubmit,
    handleCancel,
  } = useBossBabyCreatePromptTemplate();

  return (
    <Box>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Create Boss Baby Prompt Template
      </Typography>
      
      <CreateForm
        form={form}
        loading={loading}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Box>
  );
}









